// extracted by mini-css-extract-plugin
export default {"wrapper":"Disclaimer_style_wrapper__E+dqD","content":"Disclaimer_style_content__eOEfR","icon":"Disclaimer_style_icon__PsAW3","rotate":"Disclaimer_style_rotate__Ak7Pw"};